import React from 'react';
import { changeLocale, IntlContextConsumer, useIntl } from 'gatsby-plugin-intl';


interface Props {
  baseURL?: string;
}

const LanguageSwitch = (props: Props) => {
  const { locale } = useIntl();
  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    event.preventDefault();

    changeLocale(event.target.value, props.baseURL ? props.baseURL : '/');
  };

  return (
    <select onChange={handleChange} value={locale}>
      <IntlContextConsumer>
        {(intl: { languages: string[]; }) =>
          intl.languages.map((language: string) => (
            <option key={language} value={language}>
              {language.toUpperCase()}
            </option>
          ))
        }
      </IntlContextConsumer>
    </select>
  );
}

export default LanguageSwitch;
